export const EXTENSION_MESSAGE_TYPE_PREFIX = 'bs_';
export const EXTENSION_MESSAGE_TYPE = {
  GET_INFO: 'bs_get_extension_info',
  RETURN_TO_URL: 'returnToUrl',
  RETURN_TO_URL_CATEGORY: 'returnToUrlCategory',
  RESET_PASSWORD_PROTECTION_PASS: 'resetPasswordProtectionPass',
  TURN_OFF_PASSWORD_PROTECTION_CHALLENGE: 'turnOffPasswordProtectionChallenge',
};
export interface IExtensionInfo {
  extensionVersion: string;
  isInstalled: boolean | null;
  installedTime: number;
  error?: string;
}

export interface IExtensionMessage {
  type: string;
  payload?: unknown;
}

/** Response from extension when requesting user data for syncing */
export interface IExtensionUserResponse {
  readonly isAnonymous: boolean;
  readonly uid: string;
  readonly data?: readonly Record<string, unknown>[];
}
